import { Traqueur } from "./types/Traqueur.js";
import { Sentinelle } from "./types/Sentinelle.js";
import { Pulse } from "./types/Pulse.js";
import { Bombardier } from "./types/Bombardier.js";
import { NexusBoss } from "./types/NexusBoss.js";
import { SentinelleElite } from "./types/SentinelleElite.js";

/**
 * @class EnemyPool
 * @description Gère le recyclage des meshs et objets ennemis pour optimiser les performances.
 */
export class EnemyPool {
    constructor(scene) {
        this.scene = scene;
        this.pools = {
            Traqueur: [],
            Sentinelle: [],
            Pulse: [],
            Bombardier: [],
            SentinelleElite: [],
            NEXUS: []
        };
    }

    /**
     * Récupère un ennemi du pool ou en crée un nouveau.
     */
    get(type, position) {
        if (!this.pools[type]) {
            this.pools[type] = [];
        }

        let enemy = this.pools[type].find(e => e.isDestroyed);

        if (!enemy) {
            enemy = this._createEnemy(type, position);
            this.pools[type].push(enemy);
        } else {
            enemy.activate(position);
        }

        return enemy;
    }

    _createEnemy(type, position) {
        switch (type) {
            case "Traqueur":        return new Traqueur(this.scene, position);
            case "Sentinelle":      return new Sentinelle(this.scene, position);
            case "Pulse":           return new Pulse(this.scene, position);
            case "Bombardier":      return new Bombardier(this.scene, position);
            case "SentinelleElite": return new SentinelleElite(this.scene, position);
            case "NEXUS":           return new NexusBoss(this.scene, position);
            default:                return new Traqueur(this.scene, position);
        }
    }

    /**
     * Libère tous les ennemis (nettoyage complet de la scène)
     */
    disposeAll() {
        Object.values(this.pools).forEach(pool => {
            pool.forEach(enemy => enemy.dispose());
        });
        this.pools = {};
    }
}